export default "__VITE_ASSET__BGQUBvzC__"